"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Breadcrumbs = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _qa = require("../../utils/qa");
var _Icon = require("../Icon");
var _BreadcrumbsModule = _interopRequireDefault(require("./Breadcrumbs.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// Define the expected props for breadcrumb link elements

// Type for a breadcrumb link element that can be cloned

const BreadcrumbSeparator = _ref => {
  let {
    testId
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
    className: _BreadcrumbsModule.default.separator,
    name: "chevron-right",
    size: "small",
    color: "secondary",
    testId: (0, _qa.generateTestId)({
      base: testId,
      slot: 'separator'
    })
  });
};
const Breadcrumbs = exports.Breadcrumbs = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    classNames,
    children,
    linkComponent,
    testId
  } = _ref2;
  const total = React.Children.count(children);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ref: ref,
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'wrapper'
    }),
    className: (0, _classify.default)(_BreadcrumbsModule.default.wrapper, classNames?.wrapper),
    children: React.Children.map(children, (child, idx) =>
    /*#__PURE__*/
    // eslint-disable-next-line react/no-array-index-key
    (0, _jsxRuntime.jsxs)(React.Fragment, {
      children: [/*#__PURE__*/React.isValidElement(child) && child?.type?.displayName === 'BreadcrumbLink' ? /*#__PURE__*/React.cloneElement(child, {
        linkComponent,
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'breadcrumb-link',
          index: idx.toString()
        })
      }) : child, idx < total - 1 && /*#__PURE__*/(0, _jsxRuntime.jsx)(BreadcrumbSeparator, {
        testId: testId,
        "aria-hidden": true
      })]
    }, `crumb-${idx}`))
  });
});